export const ALPHANUMERIC_HYPENS=/^[a-z0-9-_]+$/i